export default __webpack_public_path__ + "static/InterDisplay-ExtraBoldItalic-ab8159c1f565127b4ff2f2bddc825dcd.woff2";